import {
  InteractionTag,
  InteractionTagPrimary,
  Menu,
  MenuList,
  MenuPopover,
  MenuTrigger,
  useOverflowMenu,
} from "@fluentui/react-components";

import { OverflowMenuItem } from "./OverflowMenuItem";

export const OverflowMenu = ({ defaultItems }) => {
  const { ref, isOverflowing, overflowCount } = useOverflowMenu<HTMLButtonElement>();

  if (!isOverflowing) {
    return null;
  }

  return (
    <InteractionTag>
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <InteractionTagPrimary ref={ref} aria-label={`${overflowCount} more tags`}>
            {`+${overflowCount}`}
          </InteractionTagPrimary>
        </MenuTrigger>
        <MenuPopover>
          <MenuList>
            {defaultItems.map((item) => (
              <OverflowMenuItem key={item.value} tag={item as any} />
            ))}
          </MenuList>
        </MenuPopover>
      </Menu>
    </InteractionTag>
  );
};
